import React from 'react';
import styled from 'styled-components';

const FeaturedContainer = styled.div`
  min-height: 100vh;
  padding-bottom: 5rem;
  padding: 20px;    
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 15rem;
`;

const Title = styled.h2`
  color: #333;
  font-weight: 500;
  font-size: 5rem;
  margin-bottom: 5rem;
`;

const Message = styled.p`
  color: #555;
  font-weight: 500;
  font-size: 3rem;
  margin-bottom: 8px;
`;

const CTA = styled.p`
  color: #555;
  font-weight: 500;
  font-size: 3rem;
  margin-bottom: 16px;
`;

const DiscordLink = styled.a`
  display: inline-block;
  padding: 10px 20px;
  color: white;
  background-color: #7289da;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s;
  font-weight: 500;
  font-size: 3rem;

  &:hover {
    background-color: #5b6eae;
  }
`;

const Featured = () => {
  return (
    <FeaturedContainer>
      <Title>Get Featured</Title>
      <Message>Welcome to our Get Featured section!</Message>
      <CTA>To get into a premium slot please follow over onto our discord where we can better assist you one on one and find the spot that will be suit your needs!</CTA>
      <DiscordLink href="https://discord.gg/fFxHmywVsF" target="_blank" rel="noopener noreferrer">
        Join our Discord
      </DiscordLink>
    </FeaturedContainer>
  );
}

export default Featured;
